import ObjectID from 'bson-objectid';

export const getObjectId = (): string => {
	return new ObjectID().toHexString();
};

export const tokenizeStringWithQuotesBySpaces = (string: string): string[] => string.match(/("[^"]*?"|[^"\s]+)+(?=\s*|\s*$)/g) ?? [];
